import { closedNoticesValue } from '@interhyp/api-values';
import { useModules } from '@interhyp/platform-module';
import { useMemo } from 'react';
import { NoticesBanner } from "./NoticesBanner.js";
import { useNotices } from "../hooks/useNotices.js";
import { checkTags } from "./utils/checkTags.js";
import { jsx as _jsx } from "react/jsx-runtime";
const CLOSED_NOTICE_ID_STORAGE_SIZE = 20;
export function NoticesBannerConnected({
  tags,
  visibility
}) {
  const {
    notices
  } = useNotices(visibility);
  const [closedNotices, setClosedNotices] = closedNoticesValue.useValue();
  const modules = useModules();
  const moduleTags = useMemo(() => {
    return modules.modules.map(module => module.name);
  }, [modules.modules]);
  const filteredNotices = useMemo(() => {
    return notices
    // this checks if the given tags match the tags of the notice
    .filter(({
      tags: noticeTags
    }) => checkTags(noticeTags, [...tags, ...moduleTags]))
    // this checks if the user already has hidden the notification
    .filter(notice => !(closedNotices ?? []).includes(notice.id))
    // this checks if the notice should be visible based on the placement/visibility of the banner
    .filter(notice => notice.visibility === 'ALL' || visibility === 'PRIVATE' && notice.visibility === 'PRIVATE' || visibility === 'PUBLIC' && notice.visibility === 'PUBLIC');
  }, [notices, tags, moduleTags, closedNotices, visibility]);
  if (!notices || notices.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(NoticesBanner, {
    notices: filteredNotices,
    onClose: id => {
      setClosedNotices([...(closedNotices ?? []), id].slice(-CLOSED_NOTICE_ID_STORAGE_SIZE));
    }
  });
}